<template>
  <b-col>
    <div
      class="webOculto"
         @mouseover="showDescription = true"
         @mouseleave="showDescription = false"
    >
      <router-link
        class="webOculto"
        :to="{ name: 'ServiceTypeId', params: { serviceType, serviceId: 0 } }"
        :id="'descrip'+ this.titulo"
      >
        <p id="title" class="py-0 mb-5"> {{ titulo | translate }}</p>
        <p :class="['descrip d-md-none', showDescription && 'd-md-block']">{{ description | translate }}</p>
      </router-link>
      <!--<a :id="'descrip'+ this.titulo"
         :class="['descrip d-sm-none', showDescription && 'd-md-block']"
      >

      </a>-->
    </div>
  </b-col>
</template>

<script>
    export default {
      data () {
        return {
          showDescription: false,
        }
      },
      props: {
        serviceType: {
          type: String,
          default: 'web'
        },
        titulo: {
          default: 'web'
        },
        description: {
          type: String,
          default: ''
        }
      }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  a {
    text-decoration: none;
  }
  #title{
    font-family: "Open Sans", sans-serif;
    font-weight: 800;
    text-align: center;
    color: #FFFFFF;
    font-size: 1.6rem;
    opacity: 1;
    letter-spacing: -2px;
    text-shadow: black 2px 2px 1px;

    @media (min-width: 1400px) {
      font-size: 3rem;
    }
    @media (max-width: 576px) {
      font-size: 1.6rem;
    }
  }

  /* #title:hover + #descrip {
    display: block;
  } */


  .descrip{
    color: #EFF7FB !important;
    text-align: center;
    font-size: 1.2rem;
    font-style: italic;
    padding-top: 1.1rem;
    padding-left: 10%;
    padding-right: 10%;
    position: absolute;
    top: 50%;
    text-shadow: black 2px 2px 3px;
    line-height: 25px;
    font-weight: bold;

    @media (min-width: 1400px) {
      font-size: 1.2rem;
      padding-left: 28%;
      padding-right: 28%;
    }

    @media (max-width: 768px) {
      margin-top: 0;
    }
  }


  .webOculto{
    background-color: transparent;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    transition: all ease-out .3s;
    &:hover {
      background-color: #F1880085;
    }

  }


</style>



// WEBPACK FOOTER //
// src/components/Box.vue